export const FETCH_IP_BLOCKS_START = "FETCH_IP_BLOCKS_START";
export const FETCH_IP_BLOCKS_SUCCESS = "FETCH_IP_BLOCKS_SUCCESS";
export const FETCH_IP_BLOCKS_ERROR = "FETCH_IP_BLOCKS_ERROR";

export const ADD_IP_BLOCK_START = "ADD_IP_BLOCK_START";
export const ADD_IP_BLOCK_SUCCESS = "ADD_IP_BLOCK_SUCCESS";
export const ADD_IP_BLOCK_ERROR = "ADD_IP_BLOCK_ERROR";
export const ADD_IP_BLOCK_CLEAR = "ADD_IP_BLOCK_CLEAR";

export const DELETE_IP_BLOCK_START = "DELETE_IP_BLOCK_START";
export const DELETE_IP_BLOCK_DONE = "DELETE_IP_BLOCK_DONE";
